import useSWR from 'swr';
import { useConfig } from '../useConfig/useConfig';
import { useSession } from '../useSession/useSession';

export const useLoyaltyApi = () => {
  const { jwtToken } = useSession();
  const config = useConfig();

  const { data: loyaltyApi } = useSWR(
    jwtToken ? ['loyaltyApi', jwtToken] : null,
    async ([, token]: string[]) => {
      try {
        const [mybuySession, mybuyCustomer, mybuyLoyalty] = await Promise.all([
          import('@empiriecom/mybuy-session'),
          import('@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1'),
          import('@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/apis/LoyaltyApi'),
        ]);
        const { apiKeyManager, FixFeatureUrlMiddleware } = mybuySession;
        const { Configuration } = mybuyCustomer;
        const { LoyaltyApi } = mybuyLoyalty;
        return new LoyaltyApi(
          new Configuration({
            fetchApi: (input, init) => fetch(input, init),
            headers: { accept: 'application/json' },
            apiKey: token,
            middleware: [
              apiKeyManager.sessionInvalidationMiddleware,
              new FixFeatureUrlMiddleware('feature-backend-customer'),
            ],
            basePath: config.apiEndpoints.customer,
          }),
        );
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (err) {
        return null;
      }
    },
  );

  return loyaltyApi ?? null;
};

export { LoyaltyStatusResponseStatusEnum } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models/LoyaltyStatusResponse';
export { LoyaltyAccountDataType } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models/LoyaltyAccountDataType';
export {
  GetLoyaltyEntitlementConsentTypeEnum,
  GetLoyaltyEntitlementConsentEntitlementTypeEnum,
} from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/apis/LoyaltyApi';
export { LoyaltyEntitlementStatus } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models/LoyaltyEntitlementStatus';
export type { LoyaltyEntitlementItem } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models/LoyaltyEntitlementItem';
export { type LoyaltyStatusResponse } from '@empiriecom/mybuy-frontend-api/backend-mybuy-customer/v1/models/LoyaltyStatusResponse';
